"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.overwriteDisplayName = exports["default"] = void 0;

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _wrapDisplayName = _interopRequireDefault(require("recompose/wrapDisplayName"));

var setWrappedDisplayName = function setWrappedDisplayName(name) {
  return function (WrappedComponent) {
    return (0, _setDisplayName["default"])((0, _wrapDisplayName["default"])(WrappedComponent, name))(WrappedComponent);
  };
};

var overwriteDisplayName = function overwriteDisplayName(name) {
  return function (WrappedComponent) {
    return (0, _setDisplayName["default"])(name)(WrappedComponent);
  };
};

exports.overwriteDisplayName = overwriteDisplayName;
var _default = setWrappedDisplayName;
exports["default"] = _default;